// Builds a class location like "12 Guj, Unit 5, Ahmedabad, Alberta 383001, Canada".
// For In-Person activities the unit number (when present) follows the street name.
// APIs return the state / country both as ids (state_province, country) and, where joined,
// as names (province / state_province_name, class_country_name / country_name), so the
// first value that is a name - not a numeric id - is used. Empty parts are skipped.
const isId = (value) => /^\d+$/.test(String(value ?? "").trim());
const hasText = (value) => value !== null && value !== undefined && String(value).trim() !== "";
const pickName = (...values) => values.find((value) => hasText(value) && !isId(value));

export default function formatLocationAddress(location) {
  if (!location) return "";
  const unit = hasText(location.unit_number) ? `Unit ${String(location.unit_number).trim()}` : "";
  const street = [location.street_number, location.street_name].filter(hasText).map((v) => String(v).trim()).join(" ");
  const state = pickName(location.state_province_name, location.province, location.state_name, location.state_province);
  const zip = [location.zipcode, location.zip_code].find(hasText);
  const country = pickName(location.location_country_name, location.class_country_name, location.country_name, location.country);
  const stateZip = [state, zip].filter(hasText).map((v) => String(v).trim()).join(" ");
  return [street, unit, location.city, stateZip, country].filter(hasText).map((v) => String(v).trim()).join(", ");
}
